import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { ArrowDown, ArrowUp, Euro } from '../../../../components/Icon';
import { HBox } from '../../../../components/Box';
import { INVOICE_DIRECTIONS } from '../../constants';
import { selectInvoice } from '../../selectors';
import { selectConfig } from '../../../Api/selectors';
import { AppClientId } from '../../../Shared/constants';
import cn from 'classnames';
import styles from './LedgersPosting.module.css';

const TotalMarginContainer = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
`;

const Container = styled.div`
  width: ${props => props.smallTable && '100%'};
  max-width: ${props => props.smallTable && '100%'};
  padding-top: 20px;
  padding-bottom: 40px;
`;

const NUMBER_CELL = styled.div`
  min-width: ${props => (props.smallTable ? '10%' : '100px')};
  max-width: ${props => (props.smallTable ? '10%' : '100px')};
  padding: 15px;
  background: #d9d9d9;
`;

const LEDGER_CELL = styled.div`
  min-width: ${props => (props.smallTable ? '30%' : '500px')};
  max-width: ${props => (props.smallTable ? '30%' : '4000px')}
  padding: 15px;
`;

const DESCRIPTION_CELL = styled.div`
  min-width: ${props => (props.smallTable ? '30%' : '500px')};
  max-width: ${props => (props.smallTable ? '30%' : '5000px')};
  padding: 15px;
  background: #d9d9d9;
`;

const DEBIT_CELL = styled.div`
  min-width: ${props => (props.smallTable ? '15%' : '200px')};
  max-width: ${props => (props.smallTable ? '15%' : '200px')};
  padding: 15px;
`;

const CREDIT_CELL = styled.div`
  min-width: ${props => (props.smallTable ? '15%' : '200px')};
  max-width: ${props => (props.smallTable ? '15%' : '200px')};
  padding: 15px;
  background: #d9d9d9;
  min-height: 54px;
`;

const STATE = {
  showLedgers: false,
};

/* eslint-disable react/prefer-stateless-function */
class LedgersPostingComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.invoice?.direction == INVOICE_DIRECTIONS.INCOMING) {
      this.setState({ showLedgers: true });
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  get ledgersToBeReversedForIncomingInvoice() {
    switch (this.clientId) {
      case AppClientId.INDEWAL:
        return ['1508'];
        case AppClientId.IDWLEASE:
          return ['1508'];
      case AppClientId.HARRY_NIJBOER:
        return ['1508'];
      case AppClientId.HOOIKAMMER:
        return ['195010'];
      case AppClientId.IDW_GMBH:
        return [];
      case AppClientId.AUTOWIENTJES:
        return ['1550', '1551'];
      case AppClientId.AUTOHUISSALLAND:
        return ['1508'];
    }
    return [];
  }

  get ledgersToBeReversedForOutgoingInvoice() {
    switch (this.clientId) {
      case AppClientId.INDEWAL:
        return ['3020', '3021', '7000', '7100', '7200', '7001', '7003', '7203', '7050', '7150', '7250'];
      case AppClientId.IDWLEASE:
        return ['3020', '3021', '7000', '7100', '7200', '7001', '7003', '7203', '7050', '7150', '7250'];
      case AppClientId.HARRY_NIJBOER:
        return ['3020', '3021', '7000', '7100', '7200', '7001', '7003', '7203', '7050', '7150', '7250'];
      case AppClientId.HOOIKAMMER:
        return ['195310'];
      case AppClientId.IDW_GMBH:
        return [];
      case AppClientId.AUTOWIENTJES:
        return [
          '3000',
          '3002',
          '3003',
          '7400',
          '7401',
          '7403',
          '7410',
          '8000',
          '8001',
          '8012',
          '8013',
          '8016',
          '8060',
          '8061',
          '8062',
          '8400',
          '8401',
          '8402',
          '8403',
          '8081',
        ];
      case AppClientId.AUTOHUISSALLAND:
        return ['3020', '3021', '7000', '7100', '7200', '7001', '7003', '7203', '7050', '7150', '7250'];
    }
    return [];
  }

  get clientId() {
    return this.props.config.appClientId;
  }

  get rows() {
    const ledgers = this.props.ledgersEntry?.ledgers ?? [];

    return ledgers.map((l, i) => {
      const number = i + 1;
      const ledger = `${l.ledger?.ledgerNumber ?? ''} ${l.ledger?.description ?? ''}`;
      const description = l?.description;
      let debit = null;
      let credit = null;
      if (l.ledger?.type === 'debit') {
        if (l.amount >= 0) {
          debit = l.amount;
        }
        if (l.amount < 0) {
          credit = l.amount * -1;
        }
      }

      if (l.ledger?.type === 'credit') {
        if (l.amount >= 0) {
          credit = l.amount;
        }
        if (l.amount < 0) {
          debit = l.amount * -1;
        }
      }

      if (
        this.props?.invoice?.direction === INVOICE_DIRECTIONS.INCOMING &&
        this.ledgersToBeReversedForIncomingInvoice.includes(l.ledger?.ledgerNumber)
      ) {
        [debit, credit] = [credit, debit];
      }

      if (
        this.props?.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING &&
        this.ledgersToBeReversedForOutgoingInvoice.includes(l.ledger?.ledgerNumber)
      ) {
        [debit, credit] = [credit, debit];
      }

      if (
        this.clientId === AppClientId.IDW_GMBH &&
        this.props?.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING &&
        !this.props?.invoice?.exportedAt &&
        this.props?.invoice?.type === INVOICE_TYPES.INVOICE
      ) {
        [credit, debit] = [debit, credit];
      }

      debit = this.formatAmount(debit);
      credit = this.formatAmount(credit);
      return { number, ledger, description, debit, credit };
    });
  }

  formatAmount(amount) {
    if ((!amount && amount !== 0) || Number.isNaN(amount)) {
      return null;
    }

    return amount.toFixed(2);
  }

  renderArrow() {
    if (this.state.showLedgers) return <ArrowUp />;

    return <ArrowDown />;
  }

  onClick() {
    this.setState((prev, props) => {
      return { ...prev, showLedgers: !prev.showLedgers };
    });
  }

  renderLedgersTable() {
    if (!this.state.showLedgers) return '';

    return (
      <div className={cn('container-fluid p-0', styles.container)}>
        {this.renderTableHeader()}
        {this.renderTableBody()}
      </div>
    );
  }

  renderTableHeader() {
    return (
      <HBox className={styles.table}>
        <NUMBER_CELL smallTable={this.props.smallTable}>#</NUMBER_CELL>
        <LEDGER_CELL smallTable={this.props.smallTable}>{this.lbl('invoice.ledgers.column_ledger_description')}</LEDGER_CELL>
        <DESCRIPTION_CELL smallTable={this.props.smallTable}>
          {this.lbl('invoice.ledgers.column_item_description')}
        </DESCRIPTION_CELL>
        <DEBIT_CELL smallTable={this.props.smallTable}>{this.lbl('invoice.ledgers.column_debet')}</DEBIT_CELL>
        <CREDIT_CELL smallTable={this.props.smallTable}>{this.lbl('invoice.ledgers.column_credit')}</CREDIT_CELL>
      </HBox>
    );
  }

  renderTableBody() {
    if (!this.rows.length) {
      return 'No ledgers';
    }

    return this.rows.map((r, i) => {
      return (
        <HBox key={i} className={styles.table}>
          <NUMBER_CELL smallTable={this.props.smallTable}>{r.number}</NUMBER_CELL>
          <LEDGER_CELL smallTable={this.props.smallTable}>{r.ledger}</LEDGER_CELL>
          <DESCRIPTION_CELL smallTable={this.props.smallTable}>{r.description}</DESCRIPTION_CELL>
          <DEBIT_CELL smallTable={this.props.smallTable}>{r.debit ?? ''}</DEBIT_CELL>
          <CREDIT_CELL smallTable={this.props.smallTable}>{r.credit ?? ''}</CREDIT_CELL>
        </HBox>
      );
    });
  }

  renderTotalMargin() {
    let totalMargin = this.props.invoice?.ledgersEntry?.totalMargin ?? 0;
    totalMargin = this.formatAmount(totalMargin);
    return (
      this.props.invoice.direction === INVOICE_DIRECTIONS.OUTGOING && (
        <TotalMarginContainer
          style={{ width: this.props.smallTable ? '100%' : '90%', minWidth: this.props.smallTable && '100%' }}
        >
          <HBox>
            <h3 style={{fontSize : '18px'}}>{this.lbl('invoice.ledgers.totalMargin')}</h3>

            <h3 style={{fontSize : '18px'}}>
              <Euro />
              {totalMargin}
            </h3>
          </HBox>
        </TotalMarginContainer>
      )
    );
  }

  render() {
    return (
      <Container smallTable={this.props.smallTable}>
        <div onClick={this.onClick.bind(this)} style={{ paddingBottom: '20px' }}>
          <h3 style={{fontSize: '22px'}}>
            {this.lbl('invoice.ledgers.title')}
            {this.renderArrow()}
          </h3>
        </div>
        {this.renderLedgersTable()}
        {this.renderTotalMargin()}
      </Container>
    );
  }
}

LedgersPostingComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const LedgersPosting = compose(withConnect, withRouter)(LedgersPostingComp);
